import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types'; // Material UI

import { TextField } from '@material-ui/core';
export var InputTextField = function InputTextField(_ref) {
  var fullWidth = _ref.fullWidth,
      margin = _ref.margin,
      variant = _ref.variant,
      rest = _objectWithoutPropertiesLoose(_ref, ["fullWidth", "margin", "variant"]);

  return /*#__PURE__*/React.createElement(TextField, _extends({
    fullWidth: fullWidth,
    margin: margin,
    variant: variant
  }, rest));
};
InputTextField.propTypes = {
  fullWidth: PropTypes.bool,
  margin: PropTypes.string,
  variant: PropTypes.string
};
InputTextField.defaultProps = {
  fullWidth: true,
  margin: 'normal',
  variant: 'outlined'
};